import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'retenidos',
  getAllParams: ({
    from, include, completas, resueltas, page, perPage, search, to,
  }) => ({
    'filter[encargo.numero_encargo]': search,
    'filter[cerrado]': completas,
    'filter[fecha_hora_resolucion]': resueltas,
    from,
    include,
    page,
    per_page: perPage,
    to,
  }),
});
